import { Modal } from "@vds/modals";
import BaseModal from "../../../../global/components/Modals/BaseModal";
import {
  AutomaticColibrationNo,
  AutomaticColibrationText,
  AutomaticColibrationYes,
  ColibrationHeadingNo,
  ColibrationHeadingYes,
} from "../styles";
import { Body, Title } from "@vds/typography";

const ExampleModal = ({ handleOnBack }) => {
  return (
    <div>
      <AutomaticColibrationYes>
        <ColibrationHeadingYes>Yes</ColibrationHeadingYes>
        <div className="row">
          <div className="col-6">
            <img
              src={require("../../../../images/manypeople.jpg")}
              alt=""
              style={{ width: "104%", height: "60%" }}
            />
            <AutomaticColibrationText>
              <span>
                <img
                  style={{ marginTop: "-5px", marginRight: "5px" }}
                  src={require("../../../../images/green-right.png")}
                  alt=""
                />
              </span>
              <Body size="small">
                Many people in view of the stream at varying distances from the
                camera
              </Body>
            </AutomaticColibrationText>
          </div>
          <div className="col-6">
            <img
              src={require("../../../../images/singleperson-moving.jpg")}
              alt=""
              style={{ width: "95%", height: "60%" }}
            />
            <AutomaticColibrationText>
              <span>
                <img
                  style={{ marginTop: "-5px", marginRight: "5px" }}
                  src={require("../../../../images/green-right.png")}
                  alt=""
                />
              </span>
              <Body size="small">
                Single person moving around to different areas and distances
                from stream view.
              </Body>
            </AutomaticColibrationText>
          </div>
        </div>
      </AutomaticColibrationYes>
      <AutomaticColibrationNo>
        <ColibrationHeadingNo>No</ColibrationHeadingNo>
        <div className="row">
          <div className="col-6">
            <img
              src={require("../../../../images/severalpeople-samedistance.jpg")}
              alt=""
              style={{ width: "104%", height: "60%" }}
            />
            <AutomaticColibrationText>
              <span>
                <img
                  style={{ marginTop: "-5px", marginRight: "5px" }}
                  src={require("../../../../images/orange-right.png")}
                  alt=""
                />
              </span>
              <Body size="small">
                Several people, but all at same distance from camera in same
                area of stream view.
              </Body>
            </AutomaticColibrationText>
          </div>
          <div className="col-6">
            <img
              src={require("../../../../images/singleperson.jpg")}
              style={{ width: "95%", height: "60%" }}
              alt=""
            />
            <AutomaticColibrationText>
              <span>
                <img
                  style={{ marginTop: "-5px", marginRight: "5px" }}
                  src={require("../../../../images/orange-wrong.png")}
                  alt=""
                />
              </span>
              <Body size="small">Single person not in motion.</Body>
            </AutomaticColibrationText>
          </div>
        </div>
      </AutomaticColibrationNo>
    </div>
  );
};

export default ExampleModal;
